<template>
  <div class="text-center md:text-left">
    <p
      class="text-base mb-0 font-bold uppercase text-mouse"
      role="heading"
      aria-level="2"
    >
      {{ $t('general/footer/block/payment_options/title') }}
    </p>
    <div
      class="flex flex-wrap justify-center md:justify-start gap-x-6 gap-y-4 mt-4"
    >
      <div v-for="paymentOption in paymentOptions" :key="paymentOption">
        <img
          :src="`/sc/images/svgs/payment/${paymentOption}.svg`"
          :alt="paymentOption"
          width="50"
          height="30"
          loading="lazy"
          class="h-10 w-auto"
        />
      </div>
    </div>
  </div>
</template>

<script lang="ts">
export default defineComponent({
  props: {
    paymentOptions: {
      type: Array as PropType<Array<string>>,
      default: () => [
        'sofort',
        'paysafecard',
        'paypal',
        'visa',
        'amex',
        'mastercard',
      ],
    },
  },
});
</script>

<style scoped></style>
